import InfoContentMotionWrapper from "Components/MotionWrapper/InfoContentMotionWrapper";
import { renderFormattedText } from "Lib/text-utils";
import styles from "Styles/CompanySize.module.css";

const TopGoalsInfoContent = ({ heading }) => {
  return (
    <InfoContentMotionWrapper>
      <h3 className={styles.heading}>{renderFormattedText(heading)}</h3>
      <div className={styles.decorativeElements}>
        <div style={{ display: "flex", gap: "65px", marginTop: "95px" }}>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="43"
            height="62"
            viewBox="0 0 43 62"
            fill="none"
          >
            <rect
              x="5.5293"
              y="6.63543"
              width="3.15608"
              height="48.3932"
              transform="rotate(-9.2355 5.5293 6.63543)"
              fill="#D5D5D5"
            />
            <rect
              x="7.59863"
              y="52.1303"
              width="13.6763"
              height="9.46824"
              rx="4.73412"
              transform="rotate(-9.2355 7.59863 52.1303)"
              fill="#0B39A7"
            />
            <path
              d="M35.6767 15.0566L12.8756 32.1482L8.63519 6.06936L35.6767 15.0566Z"
              fill="#FCCA23"
            />
          </svg>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="43"
            height="62"
            viewBox="0 0 43 62"
            fill="none"
          >
            <rect
              x="5.5293"
              y="6.63543"
              width="3.15608"
              height="48.3932"
              transform="rotate(-9.2355 5.5293 6.63543)"
              fill="#D5D5D5"
            />
            <rect
              x="7.59863"
              y="52.1303"
              width="13.6763"
              height="9.46824"
              rx="4.73412"
              transform="rotate(-9.2355 7.59863 52.1303)"
              fill="#0B39A7"
            />
            <path
              d="M35.6767 15.0566L12.8756 32.1482L8.63519 6.06936L35.6767 15.0566Z"
              fill="#FCCA23"
            />
          </svg>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="43"
            height="62"
            viewBox="0 0 43 62"
            fill="none"
          >
            <rect
              x="5.5293"
              y="6.63543"
              width="3.15608"
              height="48.3932"
              transform="rotate(-9.2355 5.5293 6.63543)"
              fill="#D5D5D5"
            />
            <rect
              x="7.59863"
              y="52.1303"
              width="13.6763"
              height="9.46824"
              rx="4.73412"
              transform="rotate(-9.2355 7.59863 52.1303)"
              fill="#0B39A7"
            />
            <path
              d="M35.6767 15.0566L12.8756 32.1482L8.63519 6.06936L35.6767 15.0566Z"
              fill="#FCCA23"
            />
          </svg>
        </div>
      </div>
    </InfoContentMotionWrapper>
  );
};

export default TopGoalsInfoContent;
